<template>
  <div style="padding-top: 40px">
    <div>
      <p class="navadno-besedilo">
        DHCP IP rezervacija omogoča, da naprava povezana v domače omrežje, pridobi vedno isti lokalni IP naslov.
        Za konfiguracijo DHCP rezervacije sta potrebna MAC naslov uporabnikove naprave in IP naslov, ki ga izberemo
        iz ponujenega nabora. Na uporabnikovi napravi je potrebno omogočiti avtomatsko pridobivanje IP naslova (DHCP).
      </p>
    </div>
    <div v-if="!povezanoVOmrezje" class="obvestilo-splosno">
      Naprava ni priklopljena v omrežje.
      Prosimo, preverite ustreznost priklopa naprave ali nas pokličite na 064 064 064.
    </div>
    <div v-else>
      <div style="padding-top: 20px"  v-if="seznamIdRezervacij.length > 0">
        <div style="clear: right">
          <el-table :data="seznamIdRezervacij" empty-text="Ni dodanih pravil" v-loading="loadingIpRezervacij">
            <el-table-column prop="deviceName"
                             label="Naprava">
            </el-table-column>
            <el-table-column prop="deviceMac"
                             label="Mac">
            </el-table-column>
            <el-table-column prop="lanStaticIp"
                             label="IP">
            </el-table-column>
            <el-table-column align="right" width="50px">
              <template slot-scope="scope">
                <div>
                  <a @click="OdstraniIpRezervacijo(scope.row)"
                     style="cursor: pointer">
                    <img src="/static/img/Nastavitve/SpletnaPredstavitev\Icon-awesome-trash-alt.png">
                  </a>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="odmik-odstrani-vse" style="float: right">
            <el-button @click="OdstraniIpRezervacijo('all')"
                       class="tekst-gumba-odstrani okvir-gumba-odstrani velikost-gumba-odstrani">
              ODSTRANI VSE
            </el-button>
          </div>
        </div>
      </div>
      <div style="padding-top: 40px" v-if="seznamIdRezervacij.length > 0">
        <hr class="hr-stil">
      </div>
      <div style="padding-top: 40px">
        <el-form label-width="150px" :label-position="formaOrientacija" class="nova-vrstica-forma">
          <el-form-item label="Naprava">
            <el-input v-model="deviceName" class="velikost-input">
            </el-input>
          </el-form-item>
          <el-form-item label="IP">
            <el-select
              v-model="izbranIp"
              filterable
              allow-create
              default-first-option
              placeholder="Izberi ali vpiši"
              class="velikost-input">
              <el-option
                v-for="item in seznamRazpolozljivihIp"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="MAC">
            <el-select
              v-model="izbranMac"
              filterable
              allow-create
              default-first-option
              placeholder="Izberi ali vpiši"
              class="velikost-input">
              <el-option
                v-for="item in seznamRazpolozljivihMac"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="padding-top: 30px">
          <el-button type="primary" @click="DodanaIpRezervacija" class="gumb-potrdi">
            DODAJ REZERVACIJO
          </el-button>
        </div>
      </div>
      <div style="padding-top: 10px">
        <InfoKomponentaMreznaOprema/>
      </div>
    </div>
  </div>
</template>

<script>
import ClientAgent from '../../../../../assets/js/clientAgent'
import {Tooltip, Input, Button, Select, Option, MessageBox, Checkbox} from 'element-ui'
import InfoKomponentaMreznaOprema from './InfoKomponentaMreznaOprema.vue'


export default {
  name: 'RezervacijaIp',
  components: {
    InfoKomponentaMreznaOprema,
    [Button.name]: Button,
    [Input.name]: Input,
    [Select.name]: Select,
    [Checkbox.name]: Checkbox,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip
  },
  props: {
    idIzbranaOprema: {},
    povezanoVOmrezje: false
  },
  emits: ['successNotification'],
  data () {
    return {
      deviceName: '',
      izbranIp: '',
      izbranMac: '',
      formaOrientacija: 'left',
      mejnaSirina: 700,
      seznamIdRezervacij: [],
      loadingIpRezervacij: false,
      all: 'all',
      seznamRazpolozljivihIp: [],
      seznamRazpolozljivihMac: []
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    if (this.povezanoVOmrezje) {
      this.GetSeznamPortForwardPravil()
    }
  },
  methods: {
    GetIpAndMacs () {
      let param = ['idOprema=' + this.idIzbranaOprema]
      this.clientAgent.postWsRequest(
        this,
        'tr069/ipReservation/getAvailableMacsAndIpsForCreation?',
        param,
        null,
        'SetSeznamIpAndMac',
        'ErrSeznamIpAndMac')
    },
    SetSeznamIpAndMac (podatki) {
      this.seznamRazpolozljivihIp = podatki.availableIps
      this.seznamRazpolozljivihMac = podatki.availableMacs
    },
    ErrSeznamIpAndMac (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    async GetSeznamPortForwardPravil (info = null) {
      if (info !== null && (info.oprema === 'all' || info.odstranjevanje)) {
        this.$emit('successNotification')
      }
      let param = {idOprema: this.idIzbranaOprema}
      this.loadingIpRezervacij = true
      this.responseShrani = await this.clientAgent.makeRequest(
        'tr069/ipReservation/getIpReservations?',
        param
      ).catch((err) => {
        this.ErrSeznamIpRezervacij(err)
      })

      this.SetSeznamIpRezervacij(this.responseShrani)
    },
    SetSeznamIpRezervacij (podatki) {
      this.seznamIdRezervacij = podatki.reservations
      this.loadingIpRezervacij = false
      this.GetIpAndMacs()
    },
    ErrSeznamIpRezervacij (podatki) {
      this.loadingIpRezervacij = false
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    OdstraniIpRezervacijo (oprema) {
      let confirmMessage = ''
      let param = []
      if (oprema !== 'all') {
        confirmMessage = 'Ali ste prepričani, da želite odstraniti IP rezervacijo?'
        param = ['ip=' + oprema.lanStaticIp]
        param.push('mac=' + oprema.deviceMac)
        param.push('idOprema=' + this.idIzbranaOprema)
      } else {
        confirmMessage = 'Ali ste prepričani, da želite odstraniti vse IP rezervacije?'
        param = ['idOprema=' + this.idIzbranaOprema]
        param.push('others=deleteall')
      }
      MessageBox.confirm(confirmMessage, {
        confirmButtonText: 'Da',
        cancelButtonText: 'Prekliči',
        confirmButtonClass: 'gumb-potrdi',
        cancelButtonClass: 'gumb-preklici',
        customClass: 'opozorilo-dialog'
      }).then(async () => {
        this.clientAgent.postWsRequest(
          this,
          'tr069/ipReservation/deleteIpReservations',
          param,
          {'oprema': oprema, 'odstranjevanje': true},
          'SuccessIpDelete',
          'ShowErrorMsg')
      })
    },
    ShowErrorMsg (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    DodanaIpRezervacija () {
      if (typeof this.idIzbranaOprema !== 'undefined') {
        let param = ['idOprema=' + this.idIzbranaOprema]
        param.push('deviceName=' + this.deviceName)
        param.push('ip=' + this.izbranIp)
        param.push('mac=' + this.izbranMac)
        param.push('other=je')
        this.clientAgent.postWsRequest(
          this,
          'tr069/ipReservation/createIpReservation?',
          param,
          null,
          'SuccessIpReservation',
          'ErrIpReservation')
      }
    },
    async SuccessIpReservation () {
      this.izbranMac = ''
      this.izbranIp = ''
      this.deviceName = ''
      this.GetSeznamPortForwardPravil()
      this.$emit('successNotification')
    },
    async SuccessIpDelete (param, info) {
      this.GetSeznamPortForwardPravil(info)
    },
    ErrIpReservation (podatki) {
      this.ShowWarningMessage(podatki)
    }
  },
  watch: {
    idIzbranaOprema: function () {
      if (this.idIzbranaOprema !== null && this.povezanoVOmrezje) {
        this.GetSeznamPortForwardPravil()
        this.GetIpAndMacs()
      }
    }
  }
}
</script>

<style scoped src="../../../../../../static/css/Nastavitve/MreznaOprema/RezervacijaIp.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/tr069/RezervacijaIp.vue